import type { PrinterView } from '../../../../services/printers/printers.service';
import { billablePrinters, resolveFixedPrinter } from '../../hooks/fixed-printer.util';

export const REPORT_PRINTER_STORAGE_KEY = 'posReportPrinterId';

// Auto-Z target: sole billable, else valid fixed, else active main (2+ billable falls through).
export function pickAutoZPrinter(printers: PrinterView[]): PrinterView | null {
  const billables = billablePrinters(printers);
  if (billables.length === 1) {
    return billables[0];
  }
  const fixedId = resolveFixedPrinter(printers);
  if (fixedId != null) {
    const fixed = printers.find((p) => p.id === fixedId);
    if (fixed) {
      return fixed;
    }
  }
  return printers.find((p) => p.active && p.mainPrinter) ?? null;
}
